import React from 'react';
import t from 'react-translate';
import { css } from '@emotion/react';

// redux
import { useSelector } from 'react-redux';
import { getFlatCourseAliases } from 'redux/selectors/course';

// hooks
import { useLecturePageParams } from 'lecture_pages/hooks/lecture-routing';
import { useHandleReorder, useHideAddUIOnOpen } from 'lecture_pages/hooks/lecture-page-edit-top-panel';

// components
import { getCurrentLecture } from 'redux/selectors/lecture-page';
import TopPanelActionButton from './top-panel-action-button';
import { config } from '@config/config.json';

const ReorderButton = () => {
  const styles = css`
    .reorder-icon {
      transform: rotate(90deg);
    }
  `;

  const params = useLecturePageParams();
  const handleReorder = useHandleReorder();
  const hideAddUIOnOpen = useHideAddUIOnOpen();
  const currentLecture = useSelector(getCurrentLecture);
  const courseAliases = useSelector(state => getFlatCourseAliases(state, params.catalogId));
  const isLinkedLesson = !currentLecture?.isLinked;

  const handleReorderButton = () => {
    hideAddUIOnOpen();
    handleReorder();
  };

  return (
    <div css={styles}>
      <TopPanelActionButton
        icon='switch'
        tooltipText={isLinkedLesson
          ? t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.REORDER()
          : t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.REORDER_DISABLED_TEXT(courseAliases)}
        className='reorder-icon'
        disabled={!isLinkedLesson}
        onClick={handleReorderButton}
        ariaLabel={isLinkedLesson
          ? t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.REORDER()
          : t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.REORDER_DISABLED_TEXT(courseAliases)}
        dataQa={config.pendo.lectureEdit.editMenuTopPanel.reorderLessonOption}
      />
    </div>
  );
};

export default ReorderButton;
